function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider, ReactIntlErrorCode } from 'react-intl';
import { DEFAULT_LOCALE } from 'localeConstants';
import * as selectors from '../../selectors';
var _React_PureComponent;
class LanguageProvider extends (_React_PureComponent = React.PureComponent) {
    onError(err) {
        if (err.code === ReactIntlErrorCode.MISSING_DATA) {
            return;
        }
        console.error(err);
    }
    render() {
        const { langCode, translations } = this.props;
        return /*#__PURE__*/ _jsx(IntlProvider, {
            locale: langCode,
            defaultLocale: DEFAULT_LOCALE,
            messages: translations,
            onError: (err)=>this.onError(err),
            children: React.Children.only(this.props.children)
        });
    }
}
_define_property(LanguageProvider, "propTypes", {
    // Implicit props
    children: PropTypes.element.isRequired,
    langCode: PropTypes.string.isRequired,
    translations: PropTypes.object.isRequired
});
const mapStateToProps = (state)=>({
        langCode: selectors.langCode(state),
        translations: selectors.translations(state)
    });
export default connect(mapStateToProps)(LanguageProvider);
